
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_lf5uo_9",
  "inline-container": "awsui_inline-container_5a145_lf5uo_13",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_lf5uo_16"
};
  